module.exports = __webpack_public_path__ + "img/dangerscavenger-small.4c14d5cf.jpg";